import React, { useState, useEffect } from 'react';
import { getPagesContent } from '../firebase/services';
import SEO from '../Components/SEO';

const PageSection = ({ title, children }) => (
  <section className="section" style={{ paddingTop: '40px', paddingBottom: '50px', minHeight: '60vh' }}>
    <div className="container" style={{ textAlign: 'center' }}>
      <h2 className="h2 section-title" style={{ 
        marginBottom: '30px', 
        fontFamily: 'var(--ff-bangers)', 
        fontSize: '4rem', 
        color: 'var(--portland-orange)',
        textAlign: 'center',
        display: 'block',
        width: '100%'
      }}>
        {title}
      </h2>
      <div className="page-content" style={{ maxWidth: '800px', margin: '0 auto', lineHeight: '1.8', whiteSpace: 'pre-wrap' }}>
        {children}
      </div>
    </div>
  </section>
);

const DynamicPage = ({ id, title, defaultContent, canonicalPath, noIndex = false }) => {
  const [content, setContent] = useState(null);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const data = await getPagesContent();
        if (data && data[id]) {
          setContent(data[id]);
        }
      } catch (error) {
        console.error("Failed to fetch page content", error);
      }
    };
    fetchContent();
  }, [id]);

  return (
    <>
      <SEO
        title={title}
        description={`${title} - VetCare Store`}
        canonical={
          typeof window !== 'undefined' && canonicalPath
            ? `${window.location.origin}${canonicalPath}`
            : undefined
        }
        noIndex={noIndex}
        type="website"
      />
      <PageSection title={title}>
        {content ? content : defaultContent}
      </PageSection>
    </>
  );
};

export const About = () => (
  <DynamicPage 
    id="about" 
    title="About Us" 
    canonicalPath="/about"
    defaultContent={
      <>
        <p>Welcome to VetCare! We are dedicated to providing the best quality pet food and supplies for your furry friends.</p>
        <p>Our mission is to ensure every pet lives a happy and healthy life.</p>
      </>
    }  
  />
);

export const PrivacyPolicy = () => (
  <DynamicPage 
    id="privacy" 
    title="Privacy Policy" 
    canonicalPath="/privacy-policy"
    defaultContent={
      <>
        <p>At VetCare, we value your privacy. This policy outlines how we collect, use, and protect your personal information.</p>
        <p>We do not sell your data to third parties.</p>
      </>
    } 
  />
);

export const RefundPolicy = () => (
  <DynamicPage 
    id="refund" 
    title="Refund Policy" 
    canonicalPath="/refund-policy"
    defaultContent={
      <>
        <p>We offer a 30-day money-back guarantee on all unopened products.</p>
        <p>If you are not satisfied with your purchase, please contact our support team.</p>
      </>
    } 
  />
);

export const ShippingPolicy = () => (
  <DynamicPage 
    id="shipping" 
    title="Shipping Policy" 
    canonicalPath="/shipping-policy"
    defaultContent={
      <>
        <p>We ship worldwide! Standard shipping takes 5-7 business days.</p>
        <p>Free shipping on orders over $50.</p>
      </>
    } 
  />
);

export const Terms = () => (
  <DynamicPage 
    id="terms" 
    title="Terms of Service" 
    canonicalPath="/terms"
    defaultContent={
      <>
        <p>By using our website, you agree to our terms and conditions.</p>
        <p>Please read them carefully before making a purchase.</p>
      </>
    } 
  />
);

export const Contact = () => (
  <DynamicPage 
    id="contact" 
    title="Contact Us" 
    canonicalPath="/contact"
    defaultContent={
      <>
        <p>Email: support@vetcare.com</p>
        <p>Phone: 015 5355 5330</p>
        <p>Address: Damanhour - El-Rowainy St. off Abd El-Salam El-Shazly St.</p>
      </>
    } 
  />
);

export const FAQ = () => (
  <DynamicPage 
    id="faq" 
    title="Frequently Asked Questions" 
    canonicalPath="/faq"
    defaultContent={
      <div style={{marginTop: '20px'}}>
        <h3>How do I track my order?</h3>
        <p>You will receive a tracking number via email once your order ships.</p>
        <br />
        <h3>Do you offer international shipping?</h3>
        <p>Yes, we ship to most countries worldwide.</p>
      </div>
    } 
  />
);
